import React from 'react';
import {Container} from "@mui/material";
import BackGround404 from "../BackGround404/BackGround404";
import "../BackGround404/Background404.css"

const NotFound404 = (props) => {

    return (
        // <div  className={"test404"}>
        //     <Container maxWidth="xl">
        //         <a>Страницы не найдено</a>
        //         <img src={"404.png"}/>
        //         <BackGround404/>
        //
        //
        //     </Container>
        //
        // </div>

        <div className="parent404">
            <div className="block404">
                <img src={"404n.png"} alt=""/>
            </div>
        </div>

    );
};

export default NotFound404;